import { cx } from '@emotion/css';
import { forwardRef, useMemo } from 'react';
import DefaultButton from '@mui/material/Button';

import { ButtonProps } from './types';
import { buttonCx } from './styles';
import { CircularProgress } from '@julo-ui/react';

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    className,
    type = 'button',
    variant = 'primary',
    loading = false,
    ...resProps
  } = props;

  const children = !loading ? (
    props.children
  ) : (
    <CircularProgress size={24} isIndeterminate />
  );

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (props.onClick && !loading) {
      props.onClick(event);
    }
  };

  const variantMap = useMemo(() => {
    switch (variant) {
      case 'secondary':
        return 'outlined';

      case 'tertiary':
        return 'text';

      case 'primary':
      default:
        return 'contained';
    }
  }, [variant]);

  return (
    <DefaultButton
      ref={ref}
      type={type}
      className={cx(buttonCx, className)}
      color='primary'
      variant={variantMap}
      data-variant={variant}
      {...resProps}
      onClick={handleClick}
      children={children}
    />
  );
});

export default Button;
